import { Injectable } from '@angular/core';
import { THEMES } from './theme.const';
import { Theme } from './theme.model';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  themeLoaded = false;
  theme: Theme | null = null;

  constructor() { }

  loadTheme(): void {
    const currentHost = window.location.hostname;
    const defaultTheme = THEMES.find((theme: any) => theme.host.includes('default'));
    const theme = THEMES.find((theme: any) => theme.host.includes(currentHost));

    if (theme) {
      this.theme = {
        ...theme,
        host: currentHost,
      };
      if(this.theme.host === 'localhost') {
        this.theme.host = 'precheckin-dev.pierreetvacances.com';
      }
      this.setHeadData();
      this.setThemeStyle(this.theme);

    } else {
      console.error(`Loading theme error : Unable to find style for host ${window.location.hostname}`);
      this.theme = {
        ...defaultTheme,
        host: currentHost,
      };
      this.setHeadData();
      this.setThemeStyle(this.theme);
      console.error(`Default theme has been loaded`);
      // throw `Loading theme error : Unable to find style for host ${window.location.hostname}`;
    }
  }

  setThemeStyle(theme: Theme): void {
    const themeCss = `${theme.name}.css`;
    const head = window.document.getElementsByTagName('head')[0];
    let clientTheme = window.document.getElementById('client-theme') as HTMLLinkElement;

    if (clientTheme) {
      clientTheme.href = themeCss;
    } else {
      const style = window.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet';
      style.href = themeCss;
      style.onload = () => {
        this.themeLoaded = true;
      }
      head.appendChild(style);
    }
  }

  setHeadData(): void {
    const appTitle: HTMLTitleElement = document.querySelector('#appTitle');
    const appFavicon: HTMLLinkElement = document.querySelector('#appFavicon');

    if(appTitle && this.theme.appTitle) {
      appTitle.text = this.theme.appTitle;
    }

    if(appFavicon && this.theme.appFavicon) {
      appFavicon.href = this.theme.appFavicon;
    }
  }
  
}
